module.exports = __webpack_public_path__ + "img/NoDocuments.013fc121.svg";